import type { Employee, ExternalMessagingUser } from "../modules/employees/types";
import { apiGet, apiPatch, apiPost } from "./utils";

export const employeesApi = {
  getAll: async (): Promise<Employee[]> => {
    return apiGet<Employee[]>("/api/v1/employees");
  },

  getMessagingUsers: async (): Promise<ExternalMessagingUser[]> => {
    return apiGet<ExternalMessagingUser[]>("/api/v1/employees/fetch_messaging_users");
  },

  sync: async (): Promise<Employee[]> => {
    return apiPost<Employee[]>("/api/v1/employees/sync");
  },

  update: async (
    id: string,
    attributes: Partial<Employee>
  ): Promise<Employee> => {
    return apiPatch<Employee>(
      `/api/v1/employees/${id}`,
      attributes as Record<string, unknown>
    );
  },
};
